import React from 'react';
import PublicSidebar from './PublicSidebar';
import useIsPublicNavigationVisible from './useIsPublicNavigationVisible';
import PageLayout from '../app/layout/PageLayout';
import useRouteHandle from '../app/useRouteHandle';

const PublicApp = () => {
  const { routeName } = useRouteHandle();
  const isPublicNavigationVisible = useIsPublicNavigationVisible();

  return (
    <PageLayout.Root
      elements={{
        sidebar: isPublicNavigationVisible ? <PublicSidebar /> : undefined,
      }}
      routeName={routeName}
    />
  );
};

export default PublicApp;
